import { SegmentSettings } from '@fullstory/proto/fs/services/search-settings/visualizationsettings';

export const getCustomSegmentKey = (index?: number) =>
  index === undefined ? 'custom_segment' : `custom_segment_${index + 1}`;
export const getCustomSegmentLabel = (index?: number, settings?: SegmentSettings) =>
  settings?.namedSegmentDefinition?.name ||
  (index === undefined ? 'Custom Segment' : `Custom Segment ${index + 1}`);
